import React from 'react'
import './navbar.css'
const Navbar = () => {
  return (
    <div className='Container'>
    <header>
        <div class="nav-wrapper">
            <div class="logo-container">
                <span>Xuperions</span>
                {/* <img class="logo"  src="config/Metarions.png" alt="Logo"/> */}
            </div>
            <nav>
                <input class="hidden" type="checkbox" id="menuToggle"/>
                <label class="menu-btn" for="menuToggle">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" >
  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
</svg>

                </label>
                <div class="nav-container">
                    <ul class="nav-tabs">
                      
                      <a href='https://www.x.com/Xuperions'>  <li class="nav-tab"> <i class="fa fa-twitter" aria-hidden="true"></i> Twitter</li> </a>
                      <a href='https://t.me/PicaLabs'>  <li class="nav-tab"> <i class="fa fa-telegram" aria-hidden="true"></i>Telegram</li> </a>
                       
                       <a href=''> <li class="nav-tab">Contact</li> </a>
                        
                       <a href='https://discord.com/invite/JruSz6Q3'> <li class="nav-tab"> Join Discord</li> </a>
                    </ul>
                </div>
            </nav>
        </div>
    </header>

    </div>
  )
}

export default Navbar